import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { MenusceltePage } from '../menuscelte/menuscelte';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
/**
 * Generated class for the AddmenusceltaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-addmenuscelta',
  templateUrl: 'addmenuscelta.html',
})
export class AddmenusceltaPage {
  values;
  menu;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    private readonly loadingCtrl: LoadingController,
    public rest: RestApiProvider

  ) {
    this.menu = navParams.get('menu');

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddmenusceltaPage');
  }
  newMenuScelta(values: any) {
    this.values = values;
    let loading = this.loadingCtrl.create({

      spinner: 'bubbles',
      duration: 4000,

      content: 'save menu ...'

    });

   // loading.present();


    console.log(values)
    values.menu = this.menu;


    console.log(JSON.stringify(values));


      this.rest.nuovaMenuScelta(values);
      let hideFooterTimeout1 = setTimeout(() => {
      //  loading.dismiss();
        this.navCtrl.push(MenusceltePage, { menu: this.menu }).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });
  
      }, 5000);

  }
}



// WEBPACK FOOTER //
// ./src/pages/addmenuscelta/addmenuscelta.ts